import { Modal } from "antd";
import { getPaymentReceipt } from "api/GatewayApi";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useQuery } from "react-query";
const PaymentReceipt = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const { data } = useQuery(
    "PaymentReceipt",
    () => getPaymentReceipt(props.paymentID),
    {
      onSuccess: (data) => {
        // console.log(data)
      },
      onError: (error) => {
        console.log("Error:", error);
      },
    }
  );

  const close = () => {
    setOpen(false);
  };
  const onOk = () => {
    const contentDiv = document.getElementById("receipt");
    const printWindow = window.open("", "_blank");
    printWindow.document.write(
      "<html><style>@media print { body { margin: 0; padding: 0; } @page { size: 5in 6in } #receipt { width: 100%; height: 100%; visibility: visible; } }</style><body>"
    );
    printWindow.document.write(
      '<div id="receipt">' + contentDiv.innerHTML + "</div>"
    );
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.onload = function () {
      printWindow.print();
      printWindow.close();
    };
  };
  const show = (id) => {
    setOpen(true);
  };
  useImperativeHandle(
    ref,
    () => ({
      show,
      close,
    }),
    []
  );

  return (
    <Modal
      class=""
      title="Payment Receipt"
      open={open}
      onOk={onOk}
      onCancel={close}
      centered
      okText={"Download"}
    >
      <div id="receipt" dangerouslySetInnerHTML={{ __html: data }} />
    </Modal>
  );
});
export default PaymentReceipt;
